export default "__VITE_ASSET__De$3xQcn__"